import { HttpErrorResponse } from '@angular/common/http';
import { RootState } from '@next/core-lib/app';

import { SessionState } from '@next/core-lib/session';

import {
  Package,
  CropAid,
  SalesOrderPeriod,
  OrderplanPeriodData,
  OrderplanProductData,
  OrderLine,
  ProductInventoryData,
  PreferredDeliveryPeriods,
  PeriodSystem,
} from '../overview/models';
import { BemProduct, DigitalProductSubscription, OrderPlanOverviewV2 } from '../overview-v2/models';

export interface SiteState extends RootState {
  app: AppState;
}

export interface Employee {
  firstName: string;
  lastName: string;
  emailAddress: string;
  mobilePhoneNumber: string;
}

export interface AppState {
  orderPlanByPeriods?: OrderplanPeriodData[];
  orderPlanLoaded?: boolean;
  orderPlanByCropAids?: OrderplanProductData[];
  gbmOrderLines?: OrderLine[];
  packages?: Package[];
  cropAids?: CropAid[];
  proprietaryCropAids?: CropAid[];
  defaultYear?: number;
  availableYears?: number[];
  salesOrderPeriods?: SalesOrderPeriod[];
  orderedId?: number;
  preferredDeliveryPeriods?: PreferredDeliveryPeriods;
  periodSystem?: PeriodSystem;
  cropFields?: CropField[];
  cropFieldLinkType?: CropFieldLinkTypesEnum;
  shipTosWithOrders?: number[];
  customerProgress?: CustomerProgress;
  loggedInEmployee?: Employee;
  isOrderPlanOptimized?: boolean;
  orderPlanV2?: OrderPlanOverviewV2[];
  customerProductInventory?: ProductInventoryData[];
  digitalProductSubscriptions?: DigitalProductSubscription[];
  orderedBemProducts: BemProduct[];
}

export interface ArableSessionState extends SessionState {
  arable?: {
    cropYear?: number;
  };
}

export interface GetDefaultYearResponse {
  defaultYear: number;
}

export interface CropFieldsResponse {
  cropFields: CropField[];
}

export interface CropField {
  id: number;
  name: string;
  cropName: string;
  shipToId?: number;
  fertilizerShipToId?: number;
}

export interface CropFieldLink extends CropField {
  linkedToThisLocation: boolean;
}

export interface LinkCropFieldData {
  cropFields: CropField[];
}

export interface CustomerProgress {
  id: number;
  customerId: number;
  year: number;
  processes: CustomerProgressProcesses;
}

export interface CustomerProgressProcesses {
  fieldPlanCropFieldsCompleted: boolean;
  fieldPlanManurespaceCompleted: boolean;
  fieldAdviceFertilizationAdvicesCompleted: boolean;
  fieldAdviceCropProtectionAdvicesCompleted: boolean;
  orderplanningOrderCompleted: boolean;
  manurespaceCalculationsCompleted: boolean;
}

export const customerProgressForSelectionUrl =
'/arable-service/organisation/customerprogress/customers';

export enum AppInsightsEnum {
  v2SliderOn = 'V2SliderOn',
  v2SliderOff = 'V2SliderOff',
  startWithV1 = 'StartWithV1',
  startWithV2 = 'StartWithV2',
}

export enum CropFieldLinkTypesEnum {
  presales = 'presales',
  fertilizer = 'fertilizer'
}

export interface ErrorResponse<E> extends HttpErrorResponse {
  error: E;
}

export interface ValidationError {
  code: string;
  message: string;
  data?: { [key: string]: string; };
}
